import { render, staticRenderFns } from "./KerbPainting.vue?vue&type=template&id=19a234b1"
import script from "./KerbPainting.vue?vue&type=script&lang=js"
export * from "./KerbPainting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports